import { Box } from '@mui/material';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import { DRINKS_AMOUNT_ANSWERS, DrinksAmount } from '../../../providers/QuizProvider/QuizProvider.types';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import QuizContainer from '../../common/QuizContainer';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step5({ stepNumber = 5, stepsNumber = 19 }: { stepNumber?: number; stepsNumber?: number }) {
  const { setStep, setQuizData, quizData } = useQuizState();

  const handleClick = (type: DrinksAmount) => {
    setQuizData((prev) => ({
      ...prev,
      drinksAmount: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={stepNumber}
        stepsNumber={stepsNumber}
      ></QuizHeader>
      <QuizQuestion text="Over a typical week, how many drinks do you usually have?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(DRINKS_AMOUNT_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof DRINKS_AMOUNT_ANSWERS)}
              variant={ButtonType.WHITE}
              text={DRINKS_AMOUNT_ANSWERS[key as keyof typeof DRINKS_AMOUNT_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step5;
